import { TOKEN, tokenLabel } from './tokens'

const MENTION_KINDS: Record<string, string> = {
  upload: 'upload',
  image: 'image',
  img: 'image',
  video: 'video',
  audio: 'audio',
}

function bracePattern() {
  return new RegExp(TOKEN.source, 'g')
}

function mentionPattern() {
  return /@((?:upload|image|img|video|audio)_?)([1-9]\d*)/gi
}

function hasWordEdge(source: string, start: number, end: number) {
  const previous = source[start - 1]
  const next = source[end]
  return (previous !== undefined && /\w/.test(previous)) || (next !== undefined && /\w/.test(next))
}

function mentionKind(kindRaw: string) {
  return MENTION_KINDS[kindRaw.toLowerCase().replace(/_+$/, '')] ?? ''
}

function replaceMentions(text: string) {
  return text.replace(
    mentionPattern(),
    (match, kindRaw: string, number: string, offset: number, source: string) => {
      const kind = mentionKind(kindRaw)
      if (kind.length === 0 || hasWordEdge(source, offset, offset + match.length)) {
        return match
      }
      return `@${tokenLabel(`{{${kind}_${number}}}`)}`
    },
  )
}

export function readableChatText(text: string) {
  const labeled = replaceMentions(text.replace(bracePattern(), token => tokenLabel(token)))
  return labeled.replace(/\s+/g, ' ').trim()
}

export function conversationLabel(title: string, snippet: string) {
  return readableChatText(title) || readableChatText(snippet) || 'New chat'
}
